import { Directive, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[appDropzone]',
    standalone: false
})
export class DropzoneDirective {
  @Output() onFileDropped = new EventEmitter<File[]>();

  @HostBinding('style.opacity') opacity = '1';
  @HostBinding('style.border') border = '2px dashed #707070';
  @HostBinding('style.border-radius') borderRadius = '4px';
  @HostBinding('style.background-color') background = '#f4f4f4';



  dropzoneId = "dropzone";

  @HostListener('dragover', ['$event']) public onDragOver(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    this.opacity = '0.8';
    this.border = "2px solid #3B4E56";
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    this.opacity = '1';
    this.border = '2px dashed #707070';
  }

  @HostListener('drop', ['$event']) public ondrop(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    this.opacity = '1';
    this.border = '2px dashed #707070';
    const files = evt.dataTransfer.files;
    if (files.length > 0) {
      this.onFileDropped.emit(Array.from(files));
    }
  }

}
